

import React from 'react';
import Button from './Button';

const ApiKeyHelpModal = ({ isOpen, onClose }) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div 
      className="fixed inset-0 bg-black bg-opacity-75 z-50 flex justify-center items-center p-4" 
      aria-modal="true" 
      role="alertdialog"
    >
      <div className="bg-white rounded-lg shadow-2xl p-6 md:p-8 w-full max-w-2xl mx-auto space-y-6">
        <div className="text-center">
            <svg className="w-16 h-16 mx-auto text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
            <h2 className="mt-4 text-2xl font-extrabold text-secondary-800">Action Required: Configure Gemini API Key</h2>
        </div>

        <p className="text-base text-secondary-600 text-center">
          The application has stopped because it could not find a valid Google Gemini API key. 
          To protect your key, it must be configured as a secret environment variable, not written directly in the code.
        </p>

        <div className="space-y-4 text-left">
          <h3 className="text-lg font-semibold text-secondary-700">How to Fix This:</h3>
          <div className="flex items-start gap-4">
            <div className="flex-shrink-0 w-8 h-8 rounded-full bg-primary-600 text-white flex items-center justify-center font-bold text-lg">1</div>
            <div>
              <h4 className="font-semibold text-secondary-800">Get a Valid API Key</h4>
              <p className="text-sm text-secondary-600">
                If you don't have one, go to the Google AI Studio dashboard and create a new API key.
              </p>
              <a href="https://aistudio.google.com/app/apikey" target="_blank" rel="noopener noreferrer" className="text-sm font-medium text-primary-600 hover:underline">
                Go to Google AI Studio &rarr;
              </a>
            </div>
          </div>
          <div className="flex items-start gap-4">
            <div className="flex-shrink-0 w-8 h-8 rounded-full bg-primary-600 text-white flex items-center justify-center font-bold text-lg">2</div>
            <div>
              <h4 className="font-semibold text-secondary-800">Set the API Key as a Secret</h4>
              <p className="text-sm text-secondary-600">
                In your hosting environment (like AI Studio, Vercel, Netlify, etc.), find the section for managing secrets or environment variables. Create a new secret with the exact name:
              </p>
              <pre className="mt-2 text-sm bg-secondary-900 text-white p-3 rounded-md overflow-x-auto">
                <code>API_KEY</code>
              </pre>
               <p className="text-sm text-secondary-600 mt-2">
                Paste your API key as the value for this secret. The application will automatically use it.
              </p>
            </div>
          </div>
        </div>
        
        <div className="mt-8 flex justify-center">
          <Button variant="primary" size="lg" onClick={onClose}>
            I Have Set the Secret Key, Restart the App
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ApiKeyHelpModal;